<!-- <div class="mb-7">
<p-toast class="notification-message" position="top-center" />
</div> -->
<p-toast></p-toast>
@if(notifications.length > 0) {
<i class="pi pi-bell text-xl link" pBadge [value]="notifications.length" severity="danger"
    (click)="op.toggle($event)" style="margin-top: 13px !important;"></i>
}@else {
    <i class="pi pi-bell text-xl link" 
    (click)="op.toggle($event)" style="margin-top: 13px !important;"></i>
}


<p-popover #op [appendTo]="'body'">
    <div class="flex flex-column gap-3 w-25rem">
        <div>
            <span class="font-medium text-900 block mb-3">{{"menu.notifications" | translate}}</span>
            @if (notifications.length > 0) {
                <ul class="list-none p-0 m-0 flex flex-column gap-3">
                    @for (notif of notifications; track $index) {
                        <li class="flex align-items-center gap-2">
                            <p-avatar [icon]="getNotificationIcon(notif)" styleClass="mr-2"
                                [style]="getNotifIconColors(notif)"
                                shape="circle" />
                            <div style="max-width: 19rem;">
                                <span class="font-medium">{{ notif.title }}</span>
                                <div class="text-sm text-color-secondary">
                                    {{ notif.message }}
                                </div>
                                <!-- @if(notif.message.length > 100) {

                                <div class="truncated" [tp]="tpl" [tpPlacement]="'bottom'" [tpPopperWidth]="'400px'">{{
                                    notif.message}}</div>
                                <ng-template #tpl let-hide>
                                    <div class="flex align-items-center text-justify p-2"
                                        style="line-height: 13px; font-size: 11px">
                                        {{ notif.message }}
                                    </div>
                                </ng-template>
                                } @else {
                                <div class="text-sm text-color-secondary">
                                    {{ notif.message }}
                                </div>
                                } -->
                            </div>
                            <div class="flex align-items-center gap-2 text-color-secondary ml-auto text-sm">
                            @if(!notif.isForAllUsers && !notif.isForAllOperators && !notif.isForAllSellers) {
                                    <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [text]="true"
                                    pTooltip="{{ 'buttons.deleteNotif' | translate }}" tooltipPosition="bottom"
                                    (onClick)="deleteNotification(notif)" />
                              
                            }@else {
                              <p-button icon="pi pi-question-circle" severity="info" [rounded]="true" [text]="true"
                                    pTooltip="{{ 'notification.cannotBeDeleted' | translate }}" tooltipPosition="bottom"
                              />
                            }
                            </div>
                        </li>
                        @if ($index < notifications.length - 1) { 
                            <div style="border-bottom: 1px solid #dee9fc"></div>
                        }
                    }
                </ul>
            } @else {
                <span>{{ "notification.noNotifications" | translate }}</span>
            }
        </div>
    </div>
</p-popover>